// @avantia common-code
import { HpQuestionSet } from '@avantia/questionset-model';
import { HpGetPolicyDataAction } from '../actions/getPolicyDataAction';
import { applyChanges } from '../engineClient/reducers/reducerLibrary';
import { ReducerProcessor } from '../engineClient/reducers/reducerProcessor';
import { HpAction } from '../engineClient/types';
import { getPolicyMapFromAnswers } from '../tools/utilities';
import { HpClaimsActionTypes } from '../types/actionTypes';
import { HpPoliciesState } from '../types/policyTypes';
import { getInitialState } from './initialState';

const processor = new ReducerProcessor<HpPoliciesState, HpClaimsActionTypes>('Policies');

processor.add<HpGetPolicyDataAction>('POLICIES_RETRIEVED', (state, action) => {
  const { payload } = action;
  return addPoliciesToState(state, payload);
});

// We also need to process the policies after retrieving answers, since the policies are stored in the answers.
processor.add<HpGetPolicyDataAction>('ANSWERS_RETRIEVED', (state, { payload }) => {
  return addPoliciesToState(state, payload);
});

export function policiesReducer(
  state: HpPoliciesState = getInitialState().policies,
  action: HpAction<unknown>
): HpPoliciesState {
  return processor.process(state, action);
}

function addPoliciesToState(state: HpPoliciesState, payload: HpQuestionSet | undefined) {
  if (payload) {
    const policyData = getPolicyMapFromAnswers(payload.answers, payload.productId);
    return applyChanges(state, policyData);
  }

  return state;
}
